// import { useSettings } from "@/core/settingStore";
import { useEffect } from "react";
import { HtmlDataAttribute } from "#/enum";
import type { UILibraryAdapter } from "./type";
interface ThemeProviderProps {
	children: React.ReactNode;
	adapters?: UILibraryAdapter[];
}
import { ThemeColorPresets, ThemeMode } from "#/enum";
import { typographyTokens } from "./tokens/typography";

export function ThemeProvider({ children, adapters = [] }: ThemeProviderProps) {
	// const { themeMode, themeColorPresets, fontFamily, fontSize } = useSettings();

	// Update HTML class to support Tailwind dark mode
	useEffect(() => {
		const root = window.document.documentElement;
		// root.setAttribute(HtmlDataAttribute.ThemeMode, themeMode);
		root.setAttribute(HtmlDataAttribute.ThemeMode, ThemeMode.Light);
	}, []);

	// Dynamically update theme color related CSS variables
	useEffect(() => {
		const root = window.document.documentElement;
		// root.setAttribute(HtmlDataAttribute.ColorPalette, themeColorPresets);
		root.setAttribute(
			HtmlDataAttribute.ColorPalette,
			ThemeColorPresets.Default,
		);
	}, []);

	// Update font size and font family
	useEffect(() => {
		// const root = window.document.documentElement;
		// root.style.fontSize = `${fontSize}px`;

		// const body = window.document.body;
		// body.style.fontFamily = fontFamily;
		const root = window.document.documentElement;
		root.style.fontSize = `${Number(typographyTokens.fontSize.sm)}px`;
	}, []);

	// Wrap children with adapters
	const wrappedWithAdapters = adapters.reduce(
		(
			children,
			Adapter, // themeMode
		) => (
			<Adapter key={Adapter.name} mode={ThemeMode.Light}>
				{children}
			</Adapter>
		),
		children,
	);

	return wrappedWithAdapters;
}
